export const CARDS_KEYS_MAP = {
    UPLOAD: 'UPLOAD',
    SET_PRICE: 'SET_PRICE',
    CREATE_LINK: 'CREATE_LINK'
};
